import api from '..'

const individualExternalCourses = (externalCourseId: number) => {
  return api.get(
    `/administration/external_courses/${externalCourseId}/individual`
  )
}

export default individualExternalCourses
